import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { colors, fonts, glyphs, useMediaQuery } from '../../Styles';
import { useAppSelector } from '../../Store';
import { NewFieldStyles, NewInputHandles } from '../../Definitions';
import { useUser } from '../../Services';
import Setting from './SubComponents/setting';
import { NewButtonList, NewInput } from '../BaseComponents';
import { WorkerList } from './workerList';


export default function UserAdministration() {
  const { t } = useTranslation()
  const mobileXs = useMediaQuery(`(max-width: 570px)`);
  const farm = useAppSelector(({activeData}) => activeData.farm) ?? "";
  const inputRef = useRef<NewInputHandles>(null);

  const { getWorkerList, addDomainWorker, removeDomainUser } = useUser();

  useEffect(() => {
    getWorkerList(farm, true).then(e=>{if(!e) getWorkerList(farm)});
  },[farm])

  //TODO: only be able to add users if owner or admin
  return (
    <Setting
      overrides={{ content: { padding: "0px" } }}
      startEnhancer={glyphs.User({ size: "25px" })} header={t("globalSettingsPages.globalSettings.workerManagement", { defaultValue: "worker management" })}
      content={
        <div style={{ display: "grid", gridTemplateRows: "minmax(max-content, 100%) 2px 1fr", gap: "15px" }}>
          <div style={{ gridArea: "1/1/2/2", display: "flex", flexWrap: "wrap", gap: "5px", justifyContent: mobileXs ? "center" : "start", padding: "10px 20px 0px 20px" }}>
            <NewInput
              placeholder={t("user.userName", { defaultValue: "username" })}
              fieldOverrides={{
                fieldStyle: NewFieldStyles.greyTertiary
              }}
              isDisabled={false}
              ref={inputRef}
            />
            <div style={{ display: "flex", flexDirection: "row", gap: "5px" }}>
              <NewButtonList
                contents={[t("buttons.add", { defaultValue: "add" }), t("globalSettingsPages.globalSettings.remove", { defaultValue: "remove" })]}
                overrides={{
                  baseStyles: { width: "fit-content", backgroundColor: colors.greyTertiary, height: "30px", padding: "0 10px" },
                  contentStyles: { color: colors.greyDarkPrimary, textShadow: "none", ...fonts.fontSize4 },
                  hoverStyles: { backgroundColor: colors.greyLightPrimary, color: colors.greyDarkPrimary }
                }}
                disabled={[false, false]}
                onClick={(i => {
                  const username = inputRef.current?.value;
                  if (!username || typeof username !== "string") return;

                  if (i === 0) {
                    addDomainWorker(farm, username).then(() => {
                      getWorkerList(farm, true).then(e=>{if(!e) getWorkerList(farm)});
                    });
                  }
                  if (i === 1) {
                    removeDomainUser(farm, username);
                  }
                })}
              />
            </div>
          </div>
          <div style={{ gridArea: "2/1/3/2", borderTop: "2px solid "+colors.greyLightPrimary, width: "calc(100% - 40px)", margin: "0px 20px", boxSizing: "border-box" }} />
          <div style={{ gridArea: "3/1/4/2" }}><WorkerList/></div>
        </div>
      }
    />
  );
}